<form [formGroup]="financialAccountForm">
  <rkt-form class="px-5 pt-3 pb-1 bg-gray-100" [form]="financialAccountForm" [fields]="financialAccountFields" [model]="formModel" />

  @if (showDebitAuthorization) {
    <rkt-form
      class="mt-4 linx-fa-debit-authorization-form"
      [form]="debitAuthorizationForm"
      [fields]="debitAuthorizationField"
      [model]="formModel"
    />
  }

  <div class="linx-request-buttons">
    <button rktButton btnType="tertiary" class="linx-request-btn btn-clear" title="Clear" (click)="onClearBtnClick()">Clear</button>

    <button
      rktButton
      title="Continue"
      [disabled]="financialAccountForm.invalid || debitAuthorizationForm.invalid"
      (click)="onClickContinue()"
    >
      Continue
    </button>
  </div>
</form>
